import { UseMutationOptions } from '@tanstack/react-query';

import { CommunicationType } from 'domains/content/types';
import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';

import MutationKeys from './keys';

export type UpdateWhatsAppInput = {
    applicationsAccess?: string;
    name: string;
    language: string;
    components: any;
    componentsMultilingual?: Record<string, any[]>;
    communicationType?: CommunicationType;
    status?: string;
    whatsappAccountId?: string;
    whatsappNamespace?: string;
    whatsappTemplateId?: string;
};

const useUpdateWhatsApp = (
    whatsAppTemplateId: string,
    mutateOptions: UseMutationOptions<unknown, Error, UpdateWhatsAppInput>
) =>
    useMutation<UpdateWhatsAppInput>(
        MutationKeys.UPDATE_WHATSAPP_TEMPLATE,
        new PathWithID(CuredApiPaths.WHATSAPP_TEMPLATES, Number(whatsAppTemplateId)),
        mutateOptions,
        ApiMethods.PUT
    );

export default useUpdateWhatsApp;
